// #/services/registry/openApi/utils/getActionKeysFromService.ts

import { OpenApiSchemaJson } from '#/types/registry';

export function getActionKeysFromService(service: OpenApiSchemaJson) {
  if (service?.paths == null) {
    return [];
  }
  return Object.entries(service.paths)
    .map(([actionPath, action]) =>
      Object.keys(action).map((verb) => `${verb} ${actionPath}`),
    )
    .flat();
}

export default getActionKeysFromService;
